export enum OS_NAMES {
	IOS = 'ios'
}
